<div class="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center z-3">
    <div class="text-info" style="width: 4rem; height: 4rem;" role="status">
        <span class="loader"></span>
    </div>
</div>
